import React, { useEffect } from "react";
import * as microsoftTeams from "@microsoft/teams-js";
import UsageLogService from "../services/UsageLogService";

const Configure = () => {

    useEffect(() => {
        microsoftTeams.app.initialize().then(() => {

            // Tell Teams config page is ready
            microsoftTeams.app.notifyAppLoaded();
            microsoftTeams.app.notifySuccess();

            //  VERY IMPORTANT: enable Save immediately
            microsoftTeams.pages.config.setValidityState(true);

            // Register save handler
            microsoftTeams.pages.config.registerOnSaveHandler((saveEvent) => {

                microsoftTeams.pages.config.setConfig({
                    entityId: "SparkMeetMeetingTab",
                    suggestedDisplayName: "Spark Meet",
                    contentUrl: `${window.location.origin}/#/chat`,
                    websiteUrl: `${window.location.origin}/#/chat`,
                });

                saveEvent.notifySuccess();
            });
        });
    }, []);

    // Track page view for analytics
    useEffect(() => {
        microsoftTeams.app.getContext().then((context) => {
            UsageLogService.trackPageView('Configure', null);
        });
    }, []);

    const onClick = () => {
        microsoftTeams.pages.config.setValidityState(true);
    }

    return (
        <header className="header">
            <div className="header-inner-container">
                <div id="divConfig">
                    <br />
                    <input type="radio" name="notificationType" value="Create" onClick={onClick} /> Do you consent to transcribe the meeting?
                </div>
            </div>
        </header>
    );
};

export default Configure;
